import React from "react";
import { Box, Tooltip, IconButton, TableCell } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

// Columna "Detalles": botón "Ver más" que abre el modal de detalle de la
// solicitud (VerDetallesModal), con badge si tiene motivo de continuidad.
export default function CeldaDetalles({ data, isError, handleOpenDialog }) {
  return (
    <TableCell align="center">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
        <Tooltip title="Ver más" arrow placement="top">
          <IconButton
            onClick={() => handleOpenDialog(data)}
            size="small"
            sx={{
              bgcolor: isError ? "#fee2e2" : "#f1f5f9",
              "&:hover": {
                bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                transform: "scale(1.1)",
              },
              transition: "all 0.2s ease",
            }}
          >
            <VisibilityIcon
              fontSize="small"
              sx={{ color: isError ? "#b91c1c" : "#475569" }}
            />
            {data.idMotivoContinuidad > 0 && (
              <Box
                sx={{
                  position: "absolute",
                  top: -6,
                  right: -6,
                  backgroundColor: "#9c154d",
                  borderRadius: "50%",
                  fontSize: 12,
                  width: 10,
                  height: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  zIndex: 1,
                }}
              />
            )}
          </IconButton>
        </Tooltip>

      </div>
    </TableCell>
  );
}
